import React from 'react'

class Contador extends React.Component {
  constructor() {
    super();
    this.state = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  componentDidMount() {
    const { fechaFinalizacion, mostrarContador } = this.props.fancy;
    if (!fechaFinalizacion || !mostrarContador) return;

    this.myInterval = setInterval(() => {
       // Get today's date and time
      const now = new Date().getTime();
        // Find the distance between now and the count down date
      const distance = fechaFinalizacion.getTime() - now;

      const hours = Math.floor((distance % (1000 * 60 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.setState({hours, minutes, seconds})
    }, 1000)

  }

  componentWillUnmount() {
    clearInterval(this.myInterval)
  }

render () {
    const {hours, minutes, seconds } = this.state;
   
    return (
            <div className="divCountdown">
              <time style={{width: '100%'}} className="countdown" dateTime="PT00H00M00S">
                <span className="item item-hh">
                    <span className="hh-1">{ ("0" + hours).slice(-2) }</span>
                    <span className="label label-hh">horas</span> 
                  </span>
                  <span className="item item-mm">
                      <span className="mm-1">{ ("0" + minutes).slice(-2) }</span>
                      <span className="label label-mm">minutos</span>
                  </span>
                  <span className="item item-ss">
                      <span className="ss-1">{ ("0" + seconds).slice(-2) }</span>
                  </span>
                </time>
            </div>      
    )}
}

export default Contador



// WEBPACK FOOTER //
// ./src/components/Global/Contador.js